/*
 * @Author: liuziwei
 * @Date: 2023-08-07 14:37:35
 * @LastEditTime: 2023-08-23 11:35:54
 * @LastEditors: liuziwei
 * @Description: 列表页领券 banner
 * 睡觉了, 帮我关一下月亮 🌙  ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ ኈ ቼ ዽ ጿ
 */
<template minapp='mpx' xlang='wxml'>
  <!-- 领域展开 -->
  <view class="banner-container" style="{{bannerStyle.back}}">
    <!-- 券信息部分 -->
    <view class="left-area">
      <image src="{{bannerStyle.icon}}" bindtap="clickExtra" class="banner-icon" />
      <view class="coupon-area">
        <block wx:for="{{couponList}}">
          <coupon couponData="{{item}}" />
        </block>
      </view>
    </view>
    <!-- 领券操作区域 -->
    <view class="right-area" bindtap="clickExtra">
      <view class="right-text">{{ extraText }}</view>
    </view>
  </view>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import { trackEvent } from '@/common/track'

  createComponent({
    props: {
      // 下发的券数据
      couponList: {
        type: Array,
        value: () => []
      },
      // extra 文案
      extraText: {
        type: String,
        value: () => ''
      },
      // pope 活动 id
      activityId: {
        type: String | Number,
        value: () => ''
      },
      bannerStyle: {
        type: Object,
        value: () => ''
      },
      bannerIcon: String
    },
    attached() {
      // 埋点参数
      const detail = this.couponList?.map((item) => {
        const coupon = item?.coupon_info
        return {
          pope_id: this.activityId,
          batch_id: coupon?.batch_id,
          status: coupon?.couponStatusInfo?.status
        }
      })
      // 曝光埋点
      trackEvent('userteam_train_coupon_banner_sw', 'UT-火车票-领券组件-展现', {
        detail,
        pg_type: 'tickets',
        num: this.couponList?.length
      })
    },
    data: {
      // banner 左侧图标
      // bannerIcon: 'https://ut-static.udache.com/webx/sfc/PbLE806mfrMfRJ2XplCZA_didibutie.png'
    },
    methods: {
      // 点击 extra 区域
      clickExtra() {
        // 点击埋点
        trackEvent('userteam_train_coupon_banner_ck', 'UT-火车票-领券组件浮层触发入口-点击', {
          pg_type: 'tickets'
        })
        // 上报事件
        this.triggerEvent('clickExtra')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .banner-container
    height 34px
    padding 8px 15px 8px 8px
    border-radius 8px
    background #fff
    display flex
    align-items center
    justify-content space-between
    box-sizing border-box
    .left-area
      max-width calc(100% - 58px)
      display flex
      align-items center
      .coupon-area
        display flex
        overflow auto
        align-items center
      .banner-icon
        width 58px
        height 19px
        flex-shrink 0
        margin-right 8px
    .right-area
      flex-shrink 0
      line-height 0
      .right-text
        font-family PingFang SC
        font-size 12px
        font-weight 400
        line-height 12px
        color #FF4343
        position relative
        padding 9px 6px
        &::after
          content ''
          width 4px
          height 4px
          border-top 1.5px solid
          border-right 1.5px solid
          position absolute
          top 12px
          right 0
          transform rotate(45deg)
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      coupon: './coupon'
    }
  }
</script>
